export const getAttributs = (state) => state.attributs
export const getAttribut = (state) => (id) => { return state.attributs.filter((attribut) => { return attribut.id == id })[0] }
